enum ETreeNodeTypes {
  Protein = 'ProteinFormulation',
  Screen = 'Screen',
  Experiment = 'Experiment',
  Project = 'Project',
  ProjectFolder = 'ProjectFolder',
  ProjectsFolder = 'ProjectsFolder',
  Seed = 'Seed',
  Projects = 'Projects',
  ScreensFolder = 'ScreensFolder',
  ScreenLot = 'ScreenLot',
  Screens = 'Screens',
  FragmentScreen = 'FragmentScreen',
  QuickAccess = 'QuickAccess',
  Search = 'TextSearch',
  Ingredients = 'Ingredients',
  CrystalTrackv4 = 'CrystalTrackv4',
  SynchrotronTripv4 = 'SynchrotronTripv4',
  SynchrotronTripv4Folder = 'SynchrotronTripv4Folder',
  CrystalContainer = 'CrystalContainer',
  Scheduling = 'Scheduling',
  Containers = 'Containers',
  CaptureProfiles = 'CaptureProfiles',
  Config = 'Config',
  TextSearch = 'TextSearch',
  Searches = 'Searches',
  SearchesFolder = 'SearchesFolder',
  SearchAnalysis = 'SearchAnalysis',
  RecycleBin = 'RecycleBin',
  Folder = 'Folder',
  Imaging = 'Imaging',
  Setup = 'Setup',
}

export const TreeNodeTypeNames = {
  [ETreeNodeTypes.Protein]: 'Protein Formulation',
  [ETreeNodeTypes.Screen]: 'Screen',
  [ETreeNodeTypes.Experiment]: 'Experiment',
  [ETreeNodeTypes.Project]: 'Project',
  [ETreeNodeTypes.ProjectFolder]: 'Folder',
  [ETreeNodeTypes.ProjectsFolder]: 'Folder',
  [ETreeNodeTypes.Seed]: 'Seed',
  [ETreeNodeTypes.Projects]: 'Projects',
  [ETreeNodeTypes.ScreensFolder]: 'Folder',
  [ETreeNodeTypes.Screens]: 'Screens',
  [ETreeNodeTypes.FragmentScreen]: 'Fragment Screen',
  [ETreeNodeTypes.Search]: 'Search',
  [ETreeNodeTypes.SynchrotronTripv4]: 'Synchrotron Trip',
  [ETreeNodeTypes.SearchAnalysis]: 'Search and Filter',
  [ETreeNodeTypes.SearchesFolder]: 'Folder',
  [ETreeNodeTypes.Folder]: 'Folder',
};

export default ETreeNodeTypes;
